
import {
  CAPITALRX_BRAND_NAME,
  CAPITALRX_CARD_BRAND_NAME,
  CARD_NAME,
  JUDI_BRAND_NAME,
  JUDI_CARD_BRAND_NAME,
  SAVINGS_NAME,
 } from "@/constants/constants";
import { enableJudiHealthBranding } from "./featureFlags";

import AdvantageHeroCardImage from "@/static/images/advantage-card-banner.png";
import DiscountHeroCardImage from "@/static/images/discount-card-banner.png";
import CapRxLogo from "@/static/images/caprx-logo.svg?url";
import JudiRxLogo from "@/static/images/judi-rx.svg?url";
import AdvantageCTABanner from "@/static/images/image-woman-card-min.png";
import DiscountCTABanner from "@/static/images/discount-card-cta-banner.png";
import AdvantageTextImage from "@/static/images/image-phone-hand-min.png";
import AdvantagePrintImage from "@/static/images/image-print-min.png";
import DiscountTextImage from "@/static/images/discount-card-phone.png";
import DiscountPrintImage from "@/static/images/discount-card-paper.png";
import AdvantageCard from "@/static/images/advantage-card-min.jpg";
import DiscountCard from "@/static/images/discount-card-single.png";
import AdvantageHeaderLogo from "@/static/images/advantage-logo.svg?url";
import DiscountHeaderLogo from "@/static/images/discount-card-header.svg?url";

// Capital Rx or Judi
export const getBrandName = () => {
  if (enableJudiHealthBranding()) {
    return JUDI_BRAND_NAME;
  } else {
    return CAPITALRX_BRAND_NAME;
  }
};

// Advantage or Discount
export const getCardName = () => {
  if (enableJudiHealthBranding()) {
    return JUDI_CARD_BRAND_NAME;
  } else {
    return CAPITALRX_CARD_BRAND_NAME;
  }
}

// Capital Rx Advantage or Judi Discount
export const getCardBrandName = (clientName?: string) => {
  const brandName = clientName ? clientName : getBrandName();
  return `${brandName} ${getCardName()}`;
};

// Capital Rx Advantage Card or Judi Discount Card
export const getCardBrandText = (clientName?: string) => {
  return `${getCardBrandName(clientName)} ${CARD_NAME}`;
};

// Capital Rx Advantage Savings or Judi Discount Savings
export const getSavingsBrandText = (clientName?: string) => {
  return `${getCardBrandName(clientName)} ${SAVINGS_NAME}`;
};

export const getHomeHeroImage = () => {
  if (enableJudiHealthBranding()) {
    return DiscountHeroCardImage;
  } else {
    return AdvantageHeroCardImage;
  }
};

export const getBrandLogo = () => {
  if (enableJudiHealthBranding()) {
    return JudiRxLogo;
  } else {
    return CapRxLogo;
  }
};

export const getLogoComponentName = () => {
  if (enableJudiHealthBranding()) {
    return "judi-rx-horizontal";
  } else {
    return "caprx-horizontal";
  }
};

export const getCTABanner = () => {
  if (enableJudiHealthBranding()) {
    return DiscountCTABanner;
  } else {
    return AdvantageCTABanner;
  }
};

export const getTextCardImage = () => {
  if (enableJudiHealthBranding()) {
    return DiscountTextImage;
  } else {
    return AdvantageTextImage;
  }
};

export const getPrintCardImage = () => {
  if (enableJudiHealthBranding()) {
    return DiscountPrintImage;
  } else {
    return AdvantagePrintImage;
  }
};

export const getSingleCardImage = () => {
  if (enableJudiHealthBranding()) {
    return DiscountCard;
  } else {
    return AdvantageCard;
  }
};

export const getHeaderLogo = () => {
  if (enableJudiHealthBranding()) {
    return DiscountHeaderLogo;
  } else {
    return AdvantageHeaderLogo;
  }
};
